'use strict';

/**
 * Environment Service (wdEnvironmentService.js).
 * Environment Service.
 *
 * @version
 * 2.27.0 LIBENV-163 Fix error redirect function
 * 2.0.0 LIBENV-99 Implement bcxOauth2HttpService for native HTTP requests
 * 1.31.0 LIBENV-97 Revert breaking changes in wdEnvironmentService
 * 1.30.0 LIBENV-95 Create new Oauth2HttpService to handle native http responses
 * 1.15.0 LIBENV-53 Add validation to export wdEnvironmentService for ES6 usage
 * 1.4.1 LIBENV-29 Undefined referrer causes errors logging in
 * 1.0.0 LIBENV-1 Initialize environment library
 *
 * @author Ryan Sweeney <rsweeney@buildcentrix.com>
 * @author Erik Orozco <eorozco@intersog.com>
 * @copyright (c) 2018-2021 Build Centrix.
 */
var wdEnvironmentService = angular.module('wd.service.environment', [
    'bcx.service.http',
    'bcx.service.oauth2http',
    'wd.service.configuration',
    'wd.service.constant',
    'wd.service.http',
    'wd.service.oauth2http',
    'wd.service.permission',
    'wd.service.resource'
])
    .factory('wdEnvironmentService',
        ['$q', '$location', '$window',
            'wdConfigurationHelper', 'wdConstantHelper', 'bcxOauth2HttpService', 'wdPermissionHelper', 'wdResourceHelper', 'wdUserHelper',
            'wdConfigurationService', 'wdConstantService', 'wdPermissionService', 'wdOauth2HttpService', 'wdResourceService',
            function ($q, $location, $window,
                      wdConfigurationHelper, wdConstantHelper, bcxOauth2HttpService, wdPermissionHelper, wdResourceHelper, wdUserHelper,
                      wdConfigurationService, wdConstantService, wdPermissionService, wdOauth2HttpService, wdResourceService) {

                /**
                 * Service: Environment
                 *
                 * @since 1.0.0
                 * @type {Object}
                 */
                var service = {};

                // Service Variables
                service.configuration   = {};
                service.constants       = {};
                service.deployment      = {};
                service.permissions     = {};
                service.resources       = {};
                service.user            = {};

                /**
                 * Initialize Environment
                 *
                 * @since 1.0.0
                 * @returns {Object}
                 */
                service.initialize = function() {

                    var deferred = $q.defer();

                    // Initialize Configuration
                    wdConfigurationService.initialize()
                        .then(function () {

                            // Set Configuration
                            service.configuration = wdConfigurationHelper;

                            // Continue Loading All Other Data
                            $q.when(true)
                                .then(function () {

                                    // Initialize the wdOauth2HttpService
                                    return wdOauth2HttpService.initialize();

                                }).then(function () {

                                    // Initialize the bcxOauth2HttpService
                                    return bcxOauth2HttpService.initialize();

                                }).then(function () {

                                    // Initialize Constants
                                    return wdConstantService.initialize();

                                }).then(function () {

                                    // Initialize Permissions
                                    return wdPermissionService.initialize();

                                }).then(function () {

                                    // Initialize Resources
                                    return wdResourceService.initialize();

                                }).then(function () {

                                    service.constants     = wdConstantHelper;
                                    service.permissions   = wdPermissionHelper;
                                    service.resources     = wdResourceHelper;
                                    service.user          = wdUserHelper;

                                    // Resolve the whole service
                                    deferred.resolve(service);

                                }, function (wdEnvironmentServiceResponse) {

                                    // Error
                                    errorRedirect();
                                    deferred.reject(wdEnvironmentServiceResponse);

                                });

                        }, function(response) {

                            // We cannot continue without host configuration
                            deferred.reject(response);

                        });

                    return deferred.promise;

                };

                /******************************************************************************************************/

                /**
                 * Redirect User
                 *
                 * @since 1.0.0
                 */
                function errorRedirect() {

                    var current = $window.location.href; // Current URL becomes the Referrer
                    var referrer = current ? '?referrer=' + encodeURIComponent(current) : '';
                    $window.location.href = service.configuration.getOauth2SsoUrl() + referrer;

                }

                return service;

            }
        ]
    );
if (typeof module !== 'undefined' && module.exports) {
    module.exports = wdEnvironmentService;
}
// EOF
